import { mapKeys, snakeCase } from 'lodash'

type SnakeCase<S extends string> = S extends `${infer T}${infer U}`
  ? `${T extends Capitalize<T> ? '_' : ''}${Lowercase<T>}${SnakeCase<U>}`
  : S

export type KeysToSnakeCase<T> = {
  [K in keyof T as SnakeCase<string & K>]: T[K]
}

export const convertKeysToSnakeCase = <T extends object>(
  obj: T,
): KeysToSnakeCase<T> =>
  mapKeys(obj, (_, k) => snakeCase(k)) as KeysToSnakeCase<T>
